import $ from "jquery";
import React from "react";
import { MenuItem, SubMenu } from "react-contextmenu";

export default function SmartSignage() {
    function updateSmartSignage(data, document) {
        console.debug('SmartSignage(%o)', data);

        let svgElement = document.getElementById(data.name);
        console.debug('SmartSignage %s => %o', data.name, svgElement);

        const href = getHrefForStateImage(data.stateImage);
        // console.debug('SmartSignageHref %s', href);
        $(svgElement).attr("href", href);
    }

    function getHrefForStateImage(stateImage) {
        return `data:image/png;charset=utf-8;base64,${stateImage}`;
    }

    const SmartSignageContextMenu = (props) => {
        const {
            contextId,
            contextName,
            activeRights,
            showSettings,
            getData,
            t,
        } = props;

        return (
            <div id="contextmenu" className="contextmenu">
                {/*
                Will be used later
                {activeRights.some((item) => item.includes("Display.")) && (
                    <>
                        <MenuItem
                            onClick={() =>
                                showSettings({
                                    Data: [getData(contextId)],
                                    Type: "SmartSignage",
                                })
                            }
                            className="activeitem"
                        >
                            {t("allgemein.einstellungen")}
                        </MenuItem>
                    </>
                )}
                */}
                <MenuItem disabled>{contextName}</MenuItem>

                {activeRights.includes("Debug.ShowIds") && (
                    <>
                        <MenuItem divider />
                        <MenuItem disabled>ID: {contextId}</MenuItem>
                    </>
                )}
            </div>
        );
    };

    return {
        updateSmartSignage, SmartSignageContextMenu
    };
}